<div id="navbar-container" class="container">
    <div class='navbar'>
        <a *ngIf="showCartItem" class='ml-3 mr-3 d-block d-sm-none'>
            <button (click)="toggleSessionCart()" class="btn btn-outline-primary session-cart-opener">
                <i class="fa fa-shopping-cart" aria-hidden="true">
                </i>
                <span class="badge session-cart-count-badge">{{ sessionCartCount }}</span>
            </button>
        </a>

        <ul class='navbar-nav mr-3 bla' *ngIf="showUserMenu || showCartItem">
            <li class='text-nowrap' [routerLinkActive]="['link-active']"
                *ngIf="user.isAnonymous && showUserMenu">
                <a class="button button--secondary" [routerLink]="['/externalLogin']"
                    *ngIf="!activeEvent">
                    <span [appTranslate]="'SignIn'">Sign In</span>
                </a>
                <a class="button button--secondary" [routerLink]="['/externalLogin']" *ngIf="activeEvent"
                    [queryParams]="{id: activeEvent.readableEventId}">
                    <span [appTranslate]="'SignIn'">Sign In</span>
                </a>
            </li>
            <li class="text-nowrap" *ngIf="!user.isAnonymous && showUserMenu">
                <div class="dropdown show">
                    <a class="chevron" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="dropdown--user" *ngIf="user.firstName">{{ user.firstName }}</span>
                        <span *ngIf="!user.firstName" [appTranslate]="'MyAccount'">My Account</span>
                    </a>

                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" [routerLink]="['/myregistrations']">
                            <span [appTranslate]="'MyRegistrations'">My registrations</span>
                        </a>
                        <a class="dropdown-item" [routerLink]="['/externalProfile']" *ngIf="showProfile && !activeEvent">
                            <span [appTranslate]="'Profile'">Profile</span>
                        </a>
                        <a class="dropdown-item" [routerLink]="['/externalProfile']" *ngIf="showProfile && activeEvent"
                            [queryParams]="{id: activeEvent.readableEventId}">
                            <span [appTranslate]="'Profile'">Profile</span>
                        </a>
                        <a class="dropdown-item" [routerLink]="['/externalLogout']" *ngIf="!activeEvent">
                            <span [appTranslate]="'SignOut'">Sign Out</span>
                        </a>
                        <a class="dropdown-item" [routerLink]="['/externalLogout']" *ngIf="activeEvent"
                            [queryParams]="{id: activeEvent.readableEventId}">
                            <span [appTranslate]="'SignOut'">Sign Out</span>
                        </a>
                    </div>
                </div>
            </li>

            <li *ngIf="showCartItem" class='ml-3 mr-3 d-none d-sm-block'>
                <button (click)="toggleSessionCart()" class="btn btn-outline-primary session-cart-opener"
                        title="{{ translateLabel('SessionCartHeader', 'Session Cart') | async }}">
                    <i class="fa fa-shopping-cart" aria-hidden="true">
                    </i>
                    <span class="badge session-cart-count-badge">{{ sessionCartCount }}</span>
                </button>
            </li>

        </ul>
        <ul class='navbar-nav'>
            <li class="nav-item ">
                <a class="nav-link" [routerLink]="['/']" id="home-button"><span [appTranslate]="'Home'">Home</span></a>
            </li>
            <li *ngIf="activeEvent" class='nav-item' [routerLinkActive]="['link-active']">
                <a class="nav-link" [routerLink]="['/event']" [queryParams]="{id: activeEvent.readableEventId}">
                    <span>{{ activeEvent.eventName }}</span>
                </a>
            </li>
        </ul>
    </div>
</div>
